function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartneringInstitutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "#f29e41",
    strokeWidth: 0.9765,
    strokeMiterlimit: 10,
    cx: 32.051998,
    cy: 32.102001,
    rx: 31.292999,
    ry: 31.200001,
    id: "ellipse1",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.934,
    y: 15.53,
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    width: 13.407,
    height: 7.397,
    id: "rect1",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    points: "10.177,15.9 18.638,10.074    26.728,15.9  ",
    id: "polygon1",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.598,
    y: 22.927,
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    width: 9.986,
    height: 5.548,
    id: "rect2",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.286,
    y: 28.476,
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    width: 42.535,
    height: 3.144,
    id: "rect3",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.598,
    y: 31.619,
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    width: 38.189,
    height: 16.922,
    id: "rect4",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.934,
    y: 48.541,
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    width: 41.056,
    height: 2.959,
    id: "rect5",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    points: "19.792,41.514 19.792,33.932    17.574,33.932 17.574,48.541 19.792,48.541 19.792,44.287  ",
    id: "polyline5",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    points: "25.341,37.075 25.341,33.932    23.122,33.932 23.122,48.541 25.341,48.541 25.341,39.202  ",
    id: "polyline6",
    style: {
      display: "inline",
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    points: "30.889,42.254 30.889,33.932    28.67,33.932 28.67,48.541 30.889,48.541 30.889,44.287  ",
    id: "polyline7",
    style: {
      display: "inline",
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    points: "36.622,37.075 36.622,33.932    34.402,33.932 34.402,48.541 36.622,48.541 36.622,39.479  ",
    id: "polyline8",
    style: {
      display: "inline",
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    points: "45.499,39.479 45.499,48.541    47.719,48.541 47.719,33.932 45.499,33.932 45.499,36.519  ",
    id: "polyline10",
    style: {
      display: "inline",
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.06,
    y: 17.749,
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    width: 3.514,
    height: 2.774,
    id: "rect10",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.792,
    y: 17.749,
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    width: 3.792,
    height: 2.774,
    id: "rect11",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.091,
    y: 15.391,
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    width: 13.407,
    height: 7.398,
    id: "rect12",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    points: "38.333,15.761 46.795,9.936    54.885,15.761  ",
    id: "polygon12",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.756,
    y: 22.789,
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    width: 9.986,
    height: 5.548,
    id: "rect13",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.218,
    y: 17.61,
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    width: 3.513,
    height: 2.774,
    id: "rect14",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.949,
    y: 17.61,
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    width: 3.793,
    height: 2.774,
    id: "rect15",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 1.0835,
    strokeMiterlimit: 10,
    points: "41.985,42.623 41.985,33.561    39.767,33.561 39.767,48.17 41.985,48.17 41.985,45.582  ",
    id: "polyline9",
    style: {
      stroke: "#ff6501",
      strokeOpacity: 1
    },
    transform: "matrix(1.0033209,0,0,0.98318482,-0.13574603,0.81367035)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#ff6501",
      strokeWidth: 1.084,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 45.499014,39.872641 v -3.82906",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#ff6501",
      strokeWidth: 1.084,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 41.992111,41.885226 v 4.141636",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#ff6501",
      strokeWidth: 1.084,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 36.622332,36.053161 0.0081,3.878463",
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#ff6501",
      strokeWidth: 1.084,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 30.895203,41.103785 0.0029,3.666541",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#ff6501",
      strokeWidth: 1.084,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "m 25.342596,36.180965 0.0016,3.271956",
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#ff6501",
      strokeWidth: 1.084,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 19.806234,40.547831 -0.01552,4.072438",
    id: "path20"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartneringInstitutions);
export default __webpack_public_path__ + "static/media/partneringInstitutions.a7260fba56f1e556cbf1511551c7c81b.svg";
export { ForwardRef as ReactComponent };